module.exports = __webpack_public_path__ + "img/GIN.cc27fda7.svg";